import { useEffect, useRef, useState } from "react";

// While enabled, a file dragged anywhere over the window can be dropped, instead
// of the browser navigating away to open it. Returns whether one is over the window.
export function useFileDrop(onFile, enabled = true) {
  const [dragging, setDragging] = useState(false);
  const latest = useRef(onFile);
  latest.current = onFile;

  useEffect(() => {
    if (!enabled) {
      setDragging(false);
      return undefined;
    }
    const hasFile = (e) => Array.from(e.dataTransfer?.types || []).includes("Files");
    const onOver = (e) => {
      if (!hasFile(e)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      setDragging(true);
    };
    // relatedTarget is null only when the drag leaves the window itself.
    const onLeave = (e) => { if (!e.relatedTarget) setDragging(false); };
    const onDrop = (e) => {
      if (!hasFile(e)) return;
      e.preventDefault();
      setDragging(false);
      const file = e.dataTransfer.files?.[0];
      if (file) latest.current(file);
    };
    window.addEventListener("dragenter", onOver);
    window.addEventListener("dragover", onOver);
    window.addEventListener("dragleave", onLeave);
    window.addEventListener("drop", onDrop);
    return () => {
      window.removeEventListener("dragenter", onOver);
      window.removeEventListener("dragover", onOver);
      window.removeEventListener("dragleave", onLeave);
      window.removeEventListener("drop", onDrop);
    };
  }, [enabled]);

  return dragging;
}
